export default __webpack_public_path__ + "static/media/renters-light-gray.fea5d484.svg";